'use strict';

export function formatEdit(amount: string) {
    if (amount === undefined || amount === null || amount === "." || (typeof(amount)!="string" && isNaN(amount))) {
        return null;
    } else {
        let n: string[];
        if (amount.indexOf(".") != -1) {
            if (amount[amount.length-1] != "." && amount[amount.length-1] != "0") {
                amount = String(parseFloat(parseFloat(amount).toFixed(7)));
            }
            n = amount.split(".");
            n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return n.join(".");
        } else {
            return amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
}

export function commify() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope: any, element: any, attrs: any, ngModel: any) {
            const currency = attrs.currency || "";
            //format text going to user (model to view)
            ngModel.$formatters.push((value: any) => {
                return value ? currency + formatEdit(String(value).replace(/[^0-9.]/g, '')) : null;
            });

            $scope.formatNumbers = (object: any, key: string) => {
                object[key] = currency + formatEdit(String(object[key]).replace(/,/g, ""));
            };
        }
    };
}



// WEBPACK FOOTER //
// ./_src/ui/ownership/commify.ts